import React, { useEffect, useState, useMemo } from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Popover from 'react-bootstrap/Popover';
import Select from 'react-select';
import { MultiSelect } from 'react-multi-select-component';
import { FormGroup } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import _, { isEmpty, pick, values, cloneDeep, some, concat } from 'lodash';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { fetchAllBrandAction } from '../../Dashboard/TodoList/Samples/store/TodoList.action';
import { fetchSeason } from '../../Library/BomLibrary/store/BomLibrary.action';
import {
  setFilterSelection,
  getCustomSectionData,
  fetchRPProductInfoDetails,
  getCompanyUsers,
  getProductStatusDetails,
  fetchBomReferenceSupplier,
  fetchAllProductType,
  getCustomAttributeFreeText,
  fetchCategoryAction,
} from './store/ProductList.action';
import {
  clearLicenseData,
  clearLikenessData,
  getCatBasedOnPT,
  getLicensorAccess,
  getLicensorDetails,
  getLicenseDetails,
  getLikenessDetails,
  getSubBrandAccess,
  getMultiSubBrandDetails,
} from '../../SystemMasters/Store/SystemMasters.action';
import { fetchColorListLibrary, fetchColorGroupLibrary } from '../../Library/ColorLibary/store/ColorLibrary.action';
import CustomTooltip from '../../../Components/Tooltip/CustomTooltip';
import { createOptions, getYears, months, checkArray, CountriesList } from '../../../Components/helper';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import { useProductListingState } from './RangePlanProductListingProvider';
import { CurrentYearItemRenderer } from '../../../Components/Utility/CurrentYearDropdown';

const { timeZone } = window?.Intl?.DateTimeFormat()?.resolvedOptions() || 'Asia/Kolkata';

function FilterProductList({ activeCustomSectiondata, costingTemplateId }) {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');
  const { rangeplanId } = useParams();
  const {
    rangePlanProvider: { mainLoader, RPActiveTab },
    setRangePlanProvider,
  } = useProductListingState();
  const reducers = useSelector((redState) => redState);
  const {
    UserDetails: {
      userInfo: { userId },
      isSupplierLoggedIn,
    },
    ColorLibraryDetails: { ColorWaysLibList, ColorLibGroup: colorLibList },
    ProductListData: {
      filterSelectedData,
      productGroups,
      rangePlanCardDetail,
      filterSelectedData: {
        selectedYear,
        selectedSeason,
        selectedBrand,
        selectedSubBrand,
        selectedMonth,
        selectedProductType,
        selectedCat1,
        selectedCat2,
        selectedCat3,
        selectedCat4,
        selectedSupplier,
        selectedCompanyUser,
        selectedStatus,
        selectedDynamic,
        pageIndex,
        pageSize,
        selectedCoo,
        productGroupId,
        selectedColorway,
        selectedColorGroup,
        selectedLicensor,
        selectedLicense,
        selectedLikeness,
      },
    },
    SystemMastersDetails: { subBrandAccess, multiSubBrandList, licensorList, licenseList, likenessList },
  } = reducers;
  // Memoize localStorageFilter to prevent infinite re-renders - use rangeplan specific key
  const localStorageFilterLice = useMemo(() => {
    try {
      const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
      return JSON.parse(localStorage.getItem(storageKey)) || {};
    } catch {
      return {};
    }
  }, [rangeplanId]);

  const [state, setState] = useState({
    yearOptions: createOptions(getYears(), 'name', '_id'),
    monthOptions: createOptions(months, 'name', '_id'),
    seasonsOptions: [],
    brandOptions: [],
    category1Options: [],
    category2Options: [],
    category3Options: [],
    category4Options: [],
    supplierOptions: [],
    statusOptions: [],
    companyUserOptions: [],
    productTypeOptions: [],
    allCustomAttributes: [],
  });
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);
  const [licensorAccess, setLicensorAccess] = useState(false);
  const {
    yearOptions,
    seasonsOptions,
    brandOptions,
    monthOptions,
    category1Options,
    category2Options,
    category3Options,
    category4Options,
    supplierOptions,
    statusOptions,
    companyUserOptions,
    productTypeOptions,
    allCustomAttributes,
  } = state;

  // Get merged filter data (card details + localStorage filters) - same as ProductListNew.js
  const getMergedFilterData = (latestFilterData) => {
    const cardDetails = rangePlanCardDetail;
    const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
    const localStorageFilter = JSON.parse(localStorage.getItem(storageKey)) || {};

    // Helper function to merge arrays - prioritize localStorage over card details
    const mergeArrays = (cardArray, localArray) => {
      const localIds = Array.isArray(localArray) ? localArray : [];

      // If localStorage has data, use it; otherwise use card details
      if (localIds.length > 0) {
        return localIds;
      }

      // Only use card details if localStorage is empty
      return Array.isArray(cardArray)
        ? cardArray.map((item) => (typeof item === 'string' || typeof item === 'number' ? item : item._id || item.id || item)).filter((id) => id)
        : [];
    };

    // Helper function to merge single values - prioritize localStorage over card details
    const mergeSingleValue = (cardValue, localValue) => {
      // If localStorage has a value, use it; otherwise use card details
      if (localValue !== null && localValue !== undefined && localValue !== '') {
        return localValue;
      }

      // Only use card details if localStorage is empty
      if (cardValue) {
        if (typeof cardValue === 'string' || typeof cardValue === 'number') {
          return cardValue;
        }
        if (Array.isArray(cardValue) && cardValue.length > 0) {
          const firstItem = cardValue[0];
          return typeof firstItem === 'string' || typeof firstItem === 'number' ? firstItem : firstItem._id || firstItem.id || firstItem;
        }
        return cardValue._id || cardValue.id || cardValue;
      }
      return localValue;
    };
    
    return {
      brandId: mergeArrays(cardDetails?.brand, localStorageFilter?.selectedBrand || latestFilterData?.selectedBrand),
      seasonId: mergeArrays(cardDetails?.season, localStorageFilter?.selectedSeason || latestFilterData?.selectedSeason),
      year: mergeArrays(cardDetails?.year, localStorageFilter?.selectedYear || latestFilterData?.selectedYear),
      month: mergeArrays(cardDetails?.month, localStorageFilter?.selectedMonth || latestFilterData?.selectedMonth),
      supplierId: mergeArrays(cardDetails?.supplier, localStorageFilter?.selectedSupplier || latestFilterData?.selectedSupplier),
      catOneId: mergeArrays(cardDetails?.catOneId, localStorageFilter?.selectedCat1 || latestFilterData?.selectedCat1),
      catTwoId: mergeArrays(cardDetails?.catTwoId, localStorageFilter?.selectedCat2 || latestFilterData?.selectedCat2),
      catThreeId: mergeArrays(cardDetails?.catThreeId, localStorageFilter?.selectedCat3 || latestFilterData?.selectedCat3),
      catFourId: mergeArrays(cardDetails?.catFourId, localStorageFilter?.selectedCat4 || latestFilterData?.selectedCat4),
      createdBy: localStorageFilter?.selectedCompanyUser || latestFilterData?.selectedCompanyUser,
      statusId: mergeArrays(cardDetails?.status, localStorageFilter?.selectedStatus || latestFilterData?.selectedStatus),
      productType: mergeArrays(cardDetails?.productType, localStorageFilter?.selectedProductType || latestFilterData?.selectedProductType),
      dynamicTypes: localStorageFilter?.selectedDynamic || latestFilterData?.selectedDynamic,
      COO: mergeArrays(cardDetails?.COO, localStorageFilter?.selectedCoo || latestFilterData?.selectedCoo),
      productGroupId: mergeSingleValue(cardDetails?.productGroupId, localStorageFilter?.productGroupId || latestFilterData?.productGroupId),
      subBrandId: mergeArrays(cardDetails?.subBrand, localStorageFilter?.selectedSubBrand || latestFilterData?.selectedSubBrand),
      colorGroupId: mergeArrays(cardDetails?.colorGroup, localStorageFilter?.selectedColorGroup || latestFilterData?.selectedColorGroup),
      colorwayId: mergeArrays(
        cardDetails?.colorway,
        localStorageFilter?.selectedColorway || localStorageFilter?.colorwayId || latestFilterData?.selectedColorway,
      ),
      licensorId: mergeArrays(cardDetails?.licensor, localStorageFilter?.selectedLicensor || latestFilterData?.selectedLicensor),
      licenseId: mergeArrays(cardDetails?.license, localStorageFilter?.selectedLicense || latestFilterData?.selectedLicense),
      likenessId: mergeArrays(cardDetails?.likenessId, localStorageFilter?.selectedLikeness || latestFilterData?.selectedLikeness),
      timeZone,
      apiName: RPActiveTab,
    };
  };

  // Helper function to filter options - strictly use card details if available
  const getFilteredOptions = (allOptions, cardData, valueKey = '_id') => {
    // If card has data, ONLY show those options (strict filtering)
    if (rangePlanCardDetail && cardData && Array.isArray(cardData) && cardData.length > 0) {
      const cardIds = cardData
        .map((item) => {
          const id = typeof item === 'string' || typeof item === 'number' ? item : item._id || item.id || item;
          // Convert to string for consistent comparison (handles year number vs string ID mismatch)
          return String(id);
        })
        .filter((id) => id && id !== 'undefined' && id !== 'null');

      return allOptions.filter((option) => {
        const optionValue = String(option[valueKey]);
        return cardIds.includes(optionValue);
      });
    }

    // Only if card data is empty/null, show all options from API
    if (!cardData || (Array.isArray(cardData) && cardData.length === 0)) {
      return allOptions;
    }

    // For single values, check if card has data
    if (!Array.isArray(cardData) && cardData) {
      const cardId = String(typeof cardData === 'string' || typeof cardData === 'number' ? cardData : cardData._id || cardData.id || cardData);
      return allOptions.filter((option) => String(option[valueKey]) === cardId);
    }

    return allOptions;
  };
  // Get filtered options for each dropdown - strictly from card details
  const getSeasonOptions = () => getFilteredOptions(seasonsOptions, rangePlanCardDetail?.season);
  const getBrandOptions = () => getFilteredOptions(brandOptions, rangePlanCardDetail?.brand);
  const getYearOptions = () => getFilteredOptions(yearOptions, rangePlanCardDetail?.year);

  // Custom month options handler - supports both 'Mar' and 'Mar_2021' formats
  const getMonthOptions = () => {
    const cardMonths = rangePlanCardDetail?.month;

    if (!cardMonths || (Array.isArray(cardMonths) && cardMonths.length === 0)) {
      return monthOptions;
    }

    if (!Array.isArray(cardMonths)) {
      return monthOptions;
    }

    const monthNames = new Set();

    cardMonths.forEach((monthStr) => {
      const monthStrValue = String(monthStr);
      const match = monthStrValue.match(/^([a-zA-Z]+)(?:_(\d{4}))?$/);
      if (match) {
        const monthName = match[1];
        monthNames.add(monthName);
      } else {
        monthNames.add(monthStrValue);
      }
    });

    return monthOptions.filter((option) => {
      const optionValue = String(option._id || option.value || option.name);
      return monthNames.has(optionValue);
    });
  };

  const getSupplierOptions = () => getFilteredOptions(supplierOptions, rangePlanCardDetail?.supplier);
  const getStatusOptions = () => getFilteredOptions(statusOptions, rangePlanCardDetail?.status);
  const getProductTypeOptions = () => getFilteredOptions(productTypeOptions, rangePlanCardDetail?.productType);
  // update month options when year is selected or changed
  const monthYearBasedOptions = useMemo(() => {
    const months = getMonthOptions() || [];
    const years = (selectedYear || []).slice().sort((a, b) => {
      const yearA = typeof a === 'string' ? parseInt(a, 10) : a;
      const yearB = typeof b === 'string' ? parseInt(b, 10) : b;
      return yearA - yearB;
    });

    if (months.length > 0 && years.length > 0) {
      const combined = [];

      // Loop through months first, then years in ascending order
      months.forEach((month) => {
        years.forEach((year) => {
          const yearValue = typeof year === 'string' ? year : year?.toString();
          const monthValue = month.value || month._id || month.name;
          const monthLabel = month.label || month.name || monthValue;
          combined.push({
            ...month,
            _id: `${monthValue}_${yearValue}`,
            name: `${monthLabel} ${yearValue}`,
            label: `${monthLabel} ${yearValue}`,
            value: `${monthValue}_${yearValue}`,
            year: yearValue,
          });
        });
      });

      // Filter based on rangePlanCardDetail?.month if it exists
      const cardMonths = rangePlanCardDetail?.month;
      if (cardMonths && Array.isArray(cardMonths) && cardMonths.length > 0) {
        const cardMonthSet = new Set(cardMonths.map((m) => String(m)));
        return combined.filter((option) => {
          const optionId = String(option._id);
          return cardMonthSet.has(optionId);
        });
      }

      return combined;
    }

    return [];
  }, [selectedYear, getMonthOptions, rangePlanCardDetail?.month]);

  const clearAll = async () => {
    const obj = {
      selectedYear: [],
      selectedSeason: [],
      selectedBrand: [],
      selectedSubBrand: [],
      selectedMonth: [],
      selectedProductType: [],
      selectedCat1: [],
      selectedCat2: [],
      selectedCat3: [],
      selectedCat4: [],
      selectedSupplier: [],
      selectedCompanyUser: [],
      selectedStatus: [],
      selectedDynamic: [],
      pageIndex,
      pageSize,
      selectedCoo: [],
      productGroupId: null,
      selectedColorway: [],
      selectedColorGroup: [],
      selectedLicensor: [],
      selectedLicense: [],
      selectedLikeness: [],
    };
    const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
    localStorage.setItem(storageKey, JSON.stringify(null));
    await dispatch(setFilterSelection(obj));
    dispatch(clearLicenseData());
    dispatch(clearLikenessData());

    setRangePlanProvider((prevState) => ({ ...prevState, productsList: [], mainLoader: true }));
    const mergedFilters = getMergedFilterData(obj);
    const paramsObj = {
      ...mergedFilters,
      pageIndex: 1,
      pageSize,
      apiName: RPActiveTab,
      timeZone,
      sectionId: activeCustomSectiondata?._id,
      rangeplanId,
      costingTemplateId,
    };
    if (!subBrandAccess) {
      delete paramsObj.subBrandId;
    }
    let res = null;
    if (RPActiveTab.includes('customSections')) {
      paramsObj.apiName = 'customsection';
      res = await dispatch(getCustomSectionData(paramsObj));
    } else {
      res = await dispatch(fetchRPProductInfoDetails(paramsObj));
    }
    if (res) {
      setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
      await dispatch(setFilterSelection(paramsObj));
    }
  };

  // Derived filtered options for cascading when flag is ON
  const category1Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category1Options;
    const ptIds = Array.isArray(selectedProductType) ? selectedProductType : selectedProductType ? [selectedProductType] : [];
    if (!ptIds.length) return category1Options;
    const filtered = (category1Options || []).filter((opt) => {
      const used = opt?.isUsedProductType || [];
      const pts = opt?.productType || [];
      return used?.some?.((id) => ptIds.includes(id)) || pts?.some?.((id) => ptIds.includes(id));
    });
    return filtered?.length ? filtered : category1Options;
  }, [catBasedOnPTData, category1Options, selectedProductType]);

  const category2Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category2Options;
    const cat1 = Array.isArray(selectedCat1) ? selectedCat1 : selectedCat1 ? [selectedCat1] : [];
    if (!cat1.length) return category2Options;
    const filtered = (category2Options || []).filter((opt) => {
      const usedCat1 = opt?.isUsedCat1 || [];
      return usedCat1?.some?.((id) => cat1.includes(id));
    });
    return filtered?.length ? filtered : category2Options;
  }, [catBasedOnPTData, category2Options, selectedCat1]);

  const category3Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category3Options;
    const c1 = Array.isArray(selectedCat1) ? selectedCat1 : selectedCat1 ? [selectedCat1] : [];
    const c2 = Array.isArray(selectedCat2) ? selectedCat2 : selectedCat2 ? [selectedCat2] : [];
    if (!c1.length || !c2.length) return category3Options;
    const filtered = (category3Options || []).filter((opt) => c1.includes(opt?.categoryOneId) && c2.includes(opt?.categoryTwoId));
    return filtered?.length ? filtered : category3Options;
  }, [catBasedOnPTData, category3Options, selectedCat1, selectedCat2]);

  const category4Filtered = useMemo(() => {
    if (!catBasedOnPTData) return category4Options;
    const c1 = Array.isArray(selectedCat1) ? selectedCat1 : selectedCat1 ? [selectedCat1] : [];
    const c2 = Array.isArray(selectedCat2) ? selectedCat2 : selectedCat2 ? [selectedCat2] : [];
    const c3 = Array.isArray(selectedCat3) ? selectedCat3 : selectedCat3 ? [selectedCat3] : [];
    if (!c1.length || !c2.length || !c3.length) return category4Options;
    const filtered = (category4Options || []).filter(
      (opt) => c1.includes(opt?.categoryOneId) && c2.includes(opt?.categoryTwoId) && c3.includes(opt?.categoryThreeId),
    );
    return filtered?.length ? filtered : category4Options;
  }, [catBasedOnPTData, category4Options, selectedCat1, selectedCat2, selectedCat3]);

  const isNullish = (obj) => {
    return Object.values(obj).every((value) => {
      return value === null;
    });
  };
  const applyFilter = async () => {
    // Get the latest filter values from Redux state
    const latestFilterData = reducers.ProductListData.filterSelectedData;
    // Use latest filter data from Redux for localStorage
    const localStorageObj = {
      selectedBrand: latestFilterData.selectedBrand,
      selectedSubBrand: latestFilterData.selectedSubBrand,
      selectedSeason: latestFilterData.selectedSeason,
      selectedYear: latestFilterData.selectedYear,
      selectedMonth: latestFilterData.selectedMonth,
      selectedProductType: latestFilterData.selectedProductType,
      selectedCat1: latestFilterData.selectedCat1,
      selectedCat2: latestFilterData.selectedCat2,
      selectedCat3: latestFilterData.selectedCat3,
      selectedCat4: latestFilterData.selectedCat4,
      selectedSupplier: latestFilterData.selectedSupplier,
      selectedCompanyUser: latestFilterData.selectedCompanyUser,
      selectedStatus: latestFilterData.selectedStatus,
      selectedDynamic: latestFilterData.selectedDynamic,
      selectedCoo: latestFilterData.selectedCoo,
      productGroupId: latestFilterData.productGroupId,
      selectedColorGroup: latestFilterData.selectedColorGroup,
      selectedColorway: latestFilterData.selectedColorway,
      colorwayId: latestFilterData.selectedColorway,
      selectedLicensor: latestFilterData.selectedLicensor,
      selectedLicense: latestFilterData.selectedLicense,
      selectedLikeness: latestFilterData.selectedLikeness,
    };
    const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';

    localStorage.setItem(storageKey, JSON.stringify(localStorageObj));

    if (isNullish(latestFilterData)) {
      toasterMsg(t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.WARNING_SELECT_FILTER'), 'warning');
    } else {
      setRangePlanProvider((prevState) => ({ ...prevState, productsList: [], mainLoader: true }));
      const mergedFilters = getMergedFilterData(latestFilterData);

      const paramsObj = {
        ...mergedFilters,
        pageIndex: 1,
        pageSize,
        apiName: RPActiveTab,
        timeZone,
        sectionId: activeCustomSectiondata?._id,
        rangeplanId,
        costingTemplateId: costingTemplateId || latestFilterData.costingTemplateId,
      };
      if (!subBrandAccess) {
        delete paramsObj.subBrandId;
      }
      let res = null;
      if (RPActiveTab.includes('customSections')) {
        paramsObj.apiName = 'customsection';
        res = await dispatch(getCustomSectionData(paramsObj));
      } else {
        res = await dispatch(fetchRPProductInfoDetails(paramsObj));
      }
      if (res) {
        setRangePlanProvider((prevState) => ({ ...prevState, mainLoader: false }));
        await dispatch(setFilterSelection(paramsObj));
      }
    }
  };

  // Initialize filter selection from localStorage only once
  useEffect(() => {
    const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
    const storedFilter = JSON.parse(localStorage.getItem(storageKey));
    if (storedFilter) {
      const resolvedColorway = !isEmpty(storedFilter?.selectedColorway) ? storedFilter.selectedColorway : storedFilter?.colorwayId;
      const normalizedColorway = Array.isArray(resolvedColorway) ? resolvedColorway : resolvedColorway ? [resolvedColorway] : [];
      const filteredStoredFilter = {
        ...storedFilter,
        ...(storedFilter?.selectedSubBrand?.length ? { subBrandId: storedFilter?.selectedSubBrand } : {}),
        ...(normalizedColorway.length ? { selectedColorway: normalizedColorway } : {}),
        ...(storedFilter?.selectedLicensor?.length ? { selectedLicensor: storedFilter.selectedLicensor } : {}),
        ...(storedFilter?.selectedLicense?.length ? { selectedLicense: storedFilter.selectedLicense } : {}),
        ...(storedFilter?.selectedLikeness?.length ? { selectedLikeness: storedFilter.selectedLikeness } : {}),
        ...(storedFilter?.selectedLicensor?.length ? { licensorId: storedFilter.selectedLicensor } : {}),
        ...(storedFilter?.selectedLicense?.length ? { licenseId: storedFilter.selectedLicense } : {}),
        ...(storedFilter?.selectedLikeness?.length ? { likenessId: storedFilter.selectedLikeness } : {}),
      };
      dispatch(setFilterSelection(filteredStoredFilter));
    }
  }, [dispatch, rangeplanId]);

  // Fetch company-level flags once on mount (PT-based cascading + licensor access)
  useEffect(() => {
    const fetchCompanyFlags = async () => {
      const [ptRes, licensorRes] = await Promise.allSettled([dispatch(getCatBasedOnPT()), dispatch(getLicensorAccess())]);
      setCatBasedOnPTData(ptRes.status === 'fulfilled' ? !!ptRes.value : false);
      setLicensorAccess(licensorRes.status === 'fulfilled' ? !!licensorRes.value?.isActiveLicensor : false);
    };
    fetchCompanyFlags();
  }, [dispatch]);

  const setSeasonsBrandData = async () => {
    const seasonsRes = await dispatch(fetchSeason({ isActive: 1, loggedInUserId: userId }));
    const category = await dispatch(
      fetchAllBrandAction({
        accessedFrom: 'masters',
        loggedInUserId: userId,
      }),
    );
    const seasonsOpt = await createOptions(seasonsRes.payload, 'name', '_id');
    const brandOpt = await createOptions(category, 'name', '_id');
    setState((prevState) => ({
      ...prevState,
      seasonsOptions: seasonsOpt,
      brandOptions: brandOpt,
    }));
  };

  useEffect(() => {
    if (!isEmpty(userId)) {
      setSeasonsBrandData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, userId]);

  useEffect(() => {
    if (!userId) return;
    dispatch(
      getLicensorDetails({
        loggedInUserId: userId,
        isActive: true,
      }),
    );

    const storageKey = rangeplanId ? `rangeplan_${rangeplanId}` : 'productListing';
    const storedFilter = JSON.parse(localStorage.getItem(storageKey)) || {};

    if (storedFilter.selectedLicensor?.length > 0) {
      dispatch(
        getLicenseDetails({
          licensorIds: storedFilter.selectedLicensor,
          loggedInUserId: userId,
          isActive: true,
        }),
      );
    }
    if (storedFilter.selectedLicensor?.length > 0 && storedFilter.selectedLicense?.length > 0) {
      dispatch(
        getLikenessDetails({
          licensorIds: storedFilter.selectedLicensor,
          licenseIds: storedFilter.selectedLicense,
          loggedInUserId: userId,
          isActive: true,
        }),
      );
    }
  }, [dispatch, userId, rangeplanId]);

  // Fetch sub-brand access toggle once
  useEffect(() => {
    dispatch(getSubBrandAccess());
  }, [dispatch]);

  // Fetch colorways
  useEffect(() => {
    const fetchColorways = async () => {
      await dispatch(
        fetchColorListLibrary({
          loggedInUserId: userId,
        }),
      );
    };
    if (userId) {
      fetchColorways();
    }
  }, [dispatch, userId]);

  // Fetch color groups
  useEffect(() => {
    const fetchColorGroups = async () => {
      if (userId) {
        await dispatch(
          fetchColorGroupLibrary({
            loggedInUserId: userId,
            isDetails: true,
          }),
        );
      }
    };
    fetchColorGroups();
  }, [dispatch, userId]);

  // Fetch sub-brands when brand changes and access is enabled
  useEffect(() => {
    if (subBrandAccess && checkArray(selectedBrand)) {
      dispatch(
        getMultiSubBrandDetails({
          brandId: selectedBrand,
          isActive: 1,
        }),
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, subBrandAccess, selectedBrand?.length]);

  const setCategoryList = (catArray) => {
    catArray.forEach(async (type) => {
      const res = await dispatch(
        fetchCategoryAction({
          categoryType: type,
          loggedInUserId: userId,
        }),
      );
      if (res.code === 200) {
        const categoryList = await createOptions(res.data, 'name', '_id');
        setState((prev) => ({
          ...prev,
          [`category${type}Options`]: categoryList,
        }));
      }
    });
  };

  const handleFilterLicense = async (val, key) => {
    const newState = { ...filterSelectedData };
    if (key === 'selectedLicensor') {
      newState.selectedLicensor = val;
      if (val.length === 0) {
        newState.selectedLicense = [];
        newState.selectedLikeness = [];
        dispatch(clearLicenseData());
      } else {
        const newLicenseList = await dispatch(
          getLicenseDetails({
            licensorIds: val,
            loggedInUserId: userId,
            isActive: true,
          }),
        );
        const validLicenseIds = new Set((newLicenseList || []).map((l) => l._id));
        newState.selectedLicense = (newState.selectedLicense || []).filter((id) => validLicenseIds.has(id));
        if (newState.selectedLicense.length > 0) {
          const newLikeness = await dispatch(
            getLikenessDetails({
              licensorIds: val,
              licenseIds: newState.selectedLicense,
              loggedInUserId: userId,
              isActive: true,
            }),
          );
          const validLikenessIds = new Set((newLikeness || []).map((l) => l._id));
          newState.selectedLikeness = (newState.selectedLikeness || []).filter((id) => validLikenessIds.has(id));
        } else {
          newState.selectedLikeness = [];
          dispatch(clearLikenessData());
        }
      }
    }
    if (key === 'selectedLicense') {
      newState.selectedLicense = val;
      if (val.length === 0 || !checkArray(newState.selectedLicensor)) {
        newState.selectedLikeness = [];
        dispatch(clearLikenessData());
      } else {
        const newLikeness = await dispatch(
          getLikenessDetails({
            licensorIds: newState.selectedLicensor,
            licenseIds: val,
            loggedInUserId: userId,
            isActive: true,
          }),
        );
        const validLikenessIds = new Set((newLikeness || []).map((l) => l._id));
        newState.selectedLikeness = (newState.selectedLikeness || []).filter((id) => validLikenessIds.has(id));
      }
    }
    if (key === 'selectedLikeness') {
      newState.selectedLikeness = val;
    }
    dispatch(setFilterSelection(newState));
  };

  const setSelectedFilters = (value, keyName) => {
    const obj = {
      ...filterSelectedData,
    };
    if (keyName === 'productGroup') {
      obj.productGroupId = value?._id || null;
    } else {
      obj[keyName] = value;
      // When product type changes, prune dependent category selections based on allowed options
      if (keyName === 'selectedProductType' && catBasedOnPTData) {
        const ptIds = Array.isArray(value) ? value : value ? [value] : [];

        // Compute valid Category 1 based on product type
        const validCat1Ids = (category1Options || [])
          .filter((opt) => {
            const used = opt?.isUsedProductType || [];
            const pts = opt?.productType || [];
            return used?.some?.((id) => ptIds.includes(id)) || pts?.some?.((id) => ptIds.includes(id));
          })
          .map((o) => o?._id)
          .filter(Boolean);

        obj.selectedCat1 = (obj?.selectedCat1 || [])?.filter?.((id) => validCat1Ids.includes(id));
        if (!checkArray(obj?.selectedCat1)) {
          obj.selectedCat2 = null;
          obj.selectedCat3 = null;
          obj.selectedCat4 = null;
        }

        // Compute valid Category 2 based on remaining Cat1
        const validCat2Ids = (category2Options || [])
          .filter((opt) => {
            const usedCat1 = opt?.isUsedCat1 || [];
            return usedCat1?.some?.((id) => obj?.selectedCat1?.includes?.(id));
          })
          .map((o) => o?._id)
          .filter(Boolean);

        obj.selectedCat2 = (obj?.selectedCat2 || [])?.filter?.((id) => validCat2Ids.includes(id));
        if (!checkArray(obj?.selectedCat2)) {
          obj.selectedCat3 = null;
          obj.selectedCat4 = null;
        }
        // Compute valid Category 3 based on remaining Cat1 & Cat2
        const validCat3Ids = (category3Options || [])
          .filter((opt) => obj?.selectedCat1?.includes?.(opt?.categoryOneId) && obj?.selectedCat2?.includes?.(opt?.categoryTwoId))
          .map((o) => o?._id)
          .filter(Boolean);

        obj.selectedCat3 = (obj?.selectedCat3 || [])?.filter?.((id) => validCat3Ids.includes(id));
        if (!checkArray(obj?.selectedCat3)) {
          obj.selectedCat4 = null;
        }

        // Compute valid Category 4 based on remaining Cat1, Cat2 & Cat3
        const validCat4Ids = (category4Options || [])
          .filter(
            (opt) =>
              obj?.selectedCat1?.includes?.(opt?.categoryOneId) &&
              obj?.selectedCat2?.includes?.(opt?.categoryTwoId) &&
              obj?.selectedCat3?.includes?.(opt?.categoryThreeId),
          )
          .map((o) => o?._id)
          .filter(Boolean);

        obj.selectedCat4 = (obj?.selectedCat4 || [])?.filter?.((id) => validCat4Ids.includes(id));
      }
      if (['selectedCat2', 'selectedCat1'].includes(keyName)) {
        obj.selectedCat3 = null;
        obj.selectedCat4 = null;
      }
      if (['selectedYear'].includes(keyName)) {
        const remainingYears = obj.selectedYear || [];
        // filter selectedMonth to keep only months that match remaining years
        obj.selectedMonth = (obj.selectedMonth || []).filter((monthStr) => {
          const match = monthStr.match(/^([a-zA-Z]+)_(\d{4})$/);
          if (!match) return true; // keep if no year part
          const year = Number(match[2]);
          return remainingYears.includes(year);
        });
        //  obj.selectedMonth = null;
      }
      if (['selectedCat3'].includes(keyName)) {
        obj.selectedCat4 = null;
      }
      // Only remove sub-brands that belong to removed brands
      if (keyName === 'selectedBrand') {
        const validSubBrands =
          obj.selectedSubBrand?.filter((subBrandId) => {
            const subBrand = multiSubBrandList?.find((sb) => sb._id === subBrandId);
            return subBrand && value?.includes(subBrand.brandId);
          }) || [];
        obj.selectedSubBrand = validSubBrands;
      }
    }
    dispatch(setFilterSelection(obj));
  };

  const fetchCompanyUsers = async () => {
    const res = await dispatch(getCompanyUsers());
    if (res?.code === 200) {
      const companyUser = res?.data?.map((user) => {
        return {
          ...user,
          label: `${user?.firstName} ${user?.lastName}`,
          value: user?._id,
        };
      });
      setState((prev) => ({ ...prev, companyUserOptions: companyUser }));
    }
  };

  const fetchProductStatus = async () => {
    const res = await dispatch(
      getProductStatusDetails({
        loggedInUserId: userId,
      }),
    );
    if (res?.code === 200) {
      const stats = await createOptions(res?.data, 'name', '_id');
      setState((prev) => ({ ...prev, statusOptions: stats }));
    }
  };

  const fetchSupplier = async () => {
    const res = await dispatch(fetchBomReferenceSupplier());
    if (res.code === 200) {
      let suppliers = await createOptions(res?.data, 'name', '_id');
      suppliers = suppliers?.sort((a, b) => a?.label?.trim()?.localeCompare(b?.label?.trim(), undefined, { sensitivity: 'base' }));
      setState((prev) => ({ ...prev, supplierOptions: suppliers }));
    }
  };

  const getAllProductType = async () => {
    const params = catBasedOnPTData ? { loggedInUserId: userId, tier: 'Tier1' } : { loggedInUserId: userId };
    const res = await dispatch(fetchAllProductType(params));
    if (res?.code === 200) {
      const stats = await createOptions(res?.data, 'name', '_id');
      setState((prev) => ({ ...prev, productTypeOptions: stats }));
    }
  };

  const fetchCustomAttribute = async () => {
    const res = await dispatch(getCustomAttributeFreeText());
    if (res.code === 200) {
      let manipulatedCustomAttribute = converDropdownData(res?.data);
      manipulatedCustomAttribute = manipulatedCustomAttribute?.map((cust) => {
        cust.options = cust?.options?.map((opt) => {
          return {
            label: opt?.keyName,
            value: opt?._id,
            colId: cust?._id,
            valId: opt?._id,
          };
        });
        return cust;
      });
      setState((prev) => ({
        ...prev,
        allCustomAttributes: manipulatedCustomAttribute,
      }));
    }
  };

  const callDropDownApi = (boolState) => {
    if (boolState) {
      if (!isEmpty(userId)) {
        setCategoryList([1, 2]);
        fetchProductStatus();
        getAllProductType();
      }
      fetchSupplier();
      fetchCompanyUsers();
      fetchCustomAttribute();
    }
  };

  const converDropdownData = (allTypeData) => {
    const allData = cloneDeep(allTypeData);
    let filteredDropdownData = allData?.filter((ele) => (ele.type === 'dropdown' || ele.type === 'radio-button') && ele.isLable === true);
    if (!isEmpty(filteredDropdownData)) {
      filteredDropdownData = filteredDropdownData.map((item) => {
        const valuesForLabel = allData?.filter((ele) => item._id === ele.lableId);
        item.options = valuesForLabel;
        return item;
      });
    }
    return filteredDropdownData;
  };

  useEffect(() => {
    const brandIds = Array.isArray(selectedBrand) ? selectedBrand : [selectedBrand];
    const productTypeIds = Array.isArray(selectedProductType) ? selectedProductType : [selectedProductType];

    let validAttributes = [];
    if (brandIds.filter(Boolean).length > 0 && productTypeIds.filter(Boolean).length > 0) {
      validAttributes = allCustomAttributes.filter((cust) => {
        const matchesBrand = cust?.brand?.length ? cust.brand.some((br) => brandIds.includes(br)) : false;
        const matchesProductType = cust?.productType?.length ? cust.productType.some((pt) => productTypeIds.includes(pt)) : false;
        return matchesBrand && matchesProductType;
      });
    }
    const validColIds = validAttributes.map((attr) => attr._id);
    if (selectedDynamic?.length > 0 && validColIds.length > 0) {
      const cleanedDynamic = selectedDynamic.filter((d) => validColIds.includes(d.colId));
      if (cleanedDynamic.length !== selectedDynamic.length) {
        setSelectedFilters(cleanedDynamic, 'selectedDynamic');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedBrand?.length, selectedProductType?.length, allCustomAttributes?.length]);

  useEffect(() => {
    const callFn = async () => {
      // Always fetch Cat3 when Cat1 & Cat2 are present
      if (checkArray(selectedCat1) && checkArray(selectedCat2) && !isEmpty(userId)) {
        const category = await dispatch(
          fetchCategoryAction({
            categoryType: 3,
            loggedInUserId: userId,
            categoryOneId: selectedCat1,
            categoryTwoId: selectedCat2,
            isActive: 1,
          }),
        );
        setState((prevState) => ({
          ...prevState,
          category3Options: createOptions(category?.data, 'name', '_id'),
        }));
      }

      // Additionally fetch Cat4 when Cat3 is present
      if (checkArray(selectedCat1) && checkArray(selectedCat2) && checkArray(selectedCat3) && !isEmpty(userId)) {
        const category = await dispatch(
          fetchCategoryAction({
            categoryType: 4,
            loggedInUserId: userId,
            categoryOneId: selectedCat1,
            categoryTwoId: selectedCat2,
            categoryThreeId: selectedCat3,
            isActive: 1,
          }),
        );
        setState((prevState) => ({
          ...prevState,
          category4Options: createOptions(category?.data, 'name', '_id'),
        }));
      }
    };
    callFn();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedCat1?.length, selectedCat2?.length, selectedCat3?.length, dispatch, userId]);

  const setSelectedDynamic = (selectedDyn, parentId) => {
    let newChanges = selectedDynamic || [];
    if (checkArray(newChanges) && checkArray(selectedDyn)) {
      let parentArray = newChanges?.filter((val) => val?.colId === parentId);
      const notCurrParent = newChanges?.filter((val) => val?.colId !== parentId);
      parentArray = selectedDyn;
      newChanges = concat(parentArray, notCurrParent);
    } else if (checkArray(newChanges) && selectedDyn.length === 0) {
      newChanges = newChanges?.filter((val) => val?.colId !== parentId);
    } else {
      newChanges = selectedDyn;
    }
    setSelectedFilters(newChanges, 'selectedDynamic');
  };

  const objFilter = useMemo(
    () =>
      pick(filterSelectedData, [
        'selectedBrand',
        'selectedSubBrand',
        'selectedSeason',
        'selectedYear',
        'selectedMonth',
        'selectedProductType',
        'selectedCat1',
        'selectedCat2',
        'selectedCat3',
        'selectedCat4',
        'selectedSupplier',
        'selectedCompanyUser',
        'selectedStatus',
        'selectedDynamic',
        'selectedCoo',
        'productGroupId',
        'selectedColorway',
        'selectedColorGroup',
        'selectedLicensor',
        'selectedLicense',
        'selectedLikeness',
      ]),
    [filterSelectedData],
  );

  const checkFilterBtnActive = useMemo(() => !values(objFilter).every(_.isEmpty), [objFilter]);

  const COOOptionsList = useMemo(() => {
    if (Array.isArray(CountriesList)) {
      return CountriesList.map((cou) => {
        return { label: cou, value: cou };
      });
    }
    return [];
  }, []);

  const subBrandOptions = useMemo(() => {
    // FIRST: Check if card details has direct sub-brand restrictions
    const cardSubBrands = rangePlanCardDetail?.subBrand;
    if (cardSubBrands && Array.isArray(cardSubBrands) && cardSubBrands.length > 0) {
      // Card has specific sub-brands - show only those
      const cardSubBrandIds = cardSubBrands
        .map((item) => String(typeof item === 'string' || typeof item === 'number' ? item : item._id || item.id || item))
        .filter((id) => id && id !== 'undefined' && id !== 'null');

      const filteredSubBrands = (multiSubBrandList || []).filter((subBrand) => cardSubBrandIds.includes(String(subBrand._id)));
      return createOptions(filteredSubBrands, 'name', '_id');
    }

    // SECOND: If no direct sub-brand restrictions, check brand restrictions
    const cardBrands = rangePlanCardDetail?.brand;
    let restrictionBrandIds = [];

    if (cardBrands && Array.isArray(cardBrands) && cardBrands.length > 0) {
      // Card details has specific brands - use those as restriction
      restrictionBrandIds = cardBrands
        .map((item) => String(typeof item === 'string' || typeof item === 'number' ? item : item._id || item.id || item))
        .filter((id) => id && id !== 'undefined' && id !== 'null');
    } else if (selectedBrand && Array.isArray(selectedBrand) && selectedBrand.length > 0) {
      // No card restriction but user has selected brands - use selected brands
      restrictionBrandIds = selectedBrand.map((id) => String(id));
    }

    // Filter sub-brands based on brand restriction
    if (restrictionBrandIds.length > 0) {
      const filteredSubBrands = (multiSubBrandList || []).filter((subBrand) => restrictionBrandIds.includes(String(subBrand.brandId)));
      return createOptions(filteredSubBrands, 'name', '_id');
    }

    // If no restrictions, show all sub-brands
    return createOptions(multiSubBrandList || [], 'name', '_id');
  }, [multiSubBrandList, rangePlanCardDetail?.brand, rangePlanCardDetail?.subBrand, selectedBrand]);

  const selectedSubBrandOptions = useMemo(() => {
    return subBrandOptions.filter((val) => !isEmpty(selectedSubBrand) && selectedSubBrand.includes(val._id));
  }, [subBrandOptions, selectedSubBrand]);

  const colorwayOptions = useMemo(() => {
    if (checkArray(ColorWaysLibList)) return createOptions(ColorWaysLibList, 'refName', '_id');
    return [];
  }, [ColorWaysLibList]);

  const colorGroupOptions = useMemo(() => {
    if (checkArray(colorLibList)) {
      return createOptions(colorLibList, 'name', '_id');
    }
    return [];
  }, [colorLibList]);

  const licensorOptions = useMemo(() => {
    if (checkArray(licensorList)) return createOptions(licensorList, 'name', '_id');
    return [];
  }, [licensorList]);

  const licenseOptions = useMemo(() => {
    if (checkArray(licenseList)) return createOptions(licenseList, 'name', '_id');
    return [];
  }, [licenseList]);

  const likenessOptions = useMemo(() => {
    if (checkArray(likenessList)) return createOptions(likenessList, 'name', '_id');
    return [];
  }, [likenessList]);

  return (
    <button
      type="button"
      aria-label="filter"
      title={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.FILTER_MODAL_TITLE')}
      className={checkFilterBtnActive ? 'btn active' : 'btn'}
    >
      <OverlayTrigger
        placement="bottom"
        trigger="click"
        rootClose
        onToggle={(show) => callDropDownApi(show)}
        overlay={
          <Popover className="custom-popover horizontal-view">
            <Popover.Content>
              <div className="product-costing-filter rangeplan-filter">
                <div className="filter-text">
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_GROUP')}</p>
                      <Select
                        options={productGroups}
                        isClearable
                        className="common-select"
                        classNamePrefix="common-select"
                        value={productGroups.filter((val) => !isEmpty(productGroupId) && productGroupId === val._id)}
                        onChange={(e) => setSelectedFilters(e, 'productGroup')}
                        getOptionLabel={(option) => option.name}
                        getOptionValue={(option) => option._id}
                        placeholder={t('RANGE_PLANS.PRODUCT_LIST.PRODUCT_GROUP')}
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.FILTER_BRAND_LABEL')}</p>
                      <MultiSelect
                        name="brand"
                        options={getBrandOptions() || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={getBrandOptions().filter((val) => !isEmpty(selectedBrand) && selectedBrand.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_BRAND')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedBrand',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  {subBrandAccess && (
                    <FormGroup className="mb-2">
                      <div className="common-react-select mb-0">
                        <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.SUB_BRAND')}</p>
                        <MultiSelect
                          name="subbrand"
                          options={subBrandOptions}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={selectedSubBrandOptions}
                          labelledBy={t('RANGE_PLANS.PRODUCT_LIST.SUB_BRAND')}
                          onChange={(selected) =>
                            setSelectedFilters(
                              selected.map((val) => val._id),
                              'selectedSubBrand',
                            )
                          }
                        />
                      </div>
                    </FormGroup>
                  )}
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.FILTER_SEASON_LABEL')}</p>
                      <MultiSelect
                        name="season"
                        options={getSeasonOptions() || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={getSeasonOptions().filter((val) => !isEmpty(selectedSeason) && selectedSeason.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_SEASON')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedSeason',
                          )
                        }
                      />
                    </div>
                  </FormGroup>

                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.FILTER_YEAR_LABEL')}</p>
                      <MultiSelect
                        name="year"
                        ItemRenderer={CurrentYearItemRenderer}
                        options={getYearOptions() || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={getYearOptions().filter((val) => !isEmpty(selectedYear) && selectedYear.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_YEAR')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedYear',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.FILTER_MONTH_LABEL')}</p>
                      <MultiSelect
                        name="month"
                        options={monthYearBasedOptions || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={monthYearBasedOptions?.filter((val) => !isEmpty(selectedMonth) && selectedMonth.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_MONTH')}
                        disabled={!selectedYear || selectedYear.length === 0}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedMonth',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.PRODUCT_TYPE_LABEL')}</p>
                      <MultiSelect
                        name="productType"
                        options={getProductTypeOptions() || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={getProductTypeOptions().filter((val) => !isEmpty(selectedProductType) && selectedProductType.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_PRODUCT_TYPE')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedProductType',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.CATEGORY_1_LABEL')}</p>
                      <MultiSelect
                        name="year"
                        options={catBasedOnPTData ? category1Filtered : category1Options}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={(catBasedOnPTData ? category1Filtered : category1Options).filter(
                          (val) => !isEmpty(selectedCat1) && selectedCat1.includes(val._id),
                        )}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_CATEGORY_1')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedCat1',
                          )
                        }
                      />
                    </div>
                  </FormGroup>

                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.CATEGORY_2_LABEL')}</p>
                      <MultiSelect
                        name="year"
                        options={catBasedOnPTData ? category2Filtered : category2Options}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={(catBasedOnPTData ? category2Filtered : category2Options).filter(
                          (val) => !isEmpty(selectedCat2) && selectedCat2.includes(val._id),
                        )}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_CATEGORY_2')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedCat2',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.CATEGORY_3_LABEL')}</p>
                      <MultiSelect
                        name="year"
                        options={catBasedOnPTData ? category3Filtered : category3Options}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={(catBasedOnPTData ? category3Filtered : category3Options).filter(
                          (val) => !isEmpty(selectedCat3) && selectedCat3.includes(val._id),
                        )}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_CATEGORY_3')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedCat3',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0 placement-top">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.CATEGORY_4_LABEL')}</p>
                      <MultiSelect
                        name="year"
                        options={catBasedOnPTData ? category4Filtered : category4Options}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={(catBasedOnPTData ? category4Filtered : category4Options).filter(
                          (val) => !isEmpty(selectedCat4) && selectedCat4.includes(val._id),
                        )}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_CATEGORY_4')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedCat4',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  {!isSupplierLoggedIn && (
                    <FormGroup className="mb-2">
                      <div className="common-react-select mb-0 placement-top">
                        <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SUPPLIER')}</p>
                        <MultiSelect
                          name="supplier"
                          options={getSupplierOptions() || []}
                          className="product-custom-multiselect common-new-multiselect w-100"
                          value={getSupplierOptions().filter((val) => !isEmpty(selectedSupplier) && selectedSupplier.includes(val._id))}
                          labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_SUPLIER')}
                          onChange={(selected) =>
                            setSelectedFilters(
                              selected.map((val) => val._id),
                              'selectedSupplier',
                            )
                          }
                        />
                      </div>
                    </FormGroup>
                  )}
                  <FormGroup className="mb-2">
                    <div className="common-react-select placement-top mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.STATUS')}</p>
                      <MultiSelect
                        name="status"
                        options={getStatusOptions() || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={getStatusOptions().filter((val) => !isEmpty(selectedStatus) && selectedStatus.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_STATUS')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedStatus',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select placement-top mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.CREATED_BY')}</p>
                      <MultiSelect
                        name="year"
                        options={companyUserOptions || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={companyUserOptions.filter((val) => !isEmpty(selectedCompanyUser) && selectedCompanyUser.includes(val._id))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.CREATED')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedCompanyUser',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select placement-top mb-0">
                      <p className="field-name">{t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.COUNTRY_OF_ORIGIN_LABEL')}</p>
                      <MultiSelect
                        name="year"
                        options={COOOptionsList || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={COOOptionsList.filter((val) => !isEmpty(selectedCoo) && selectedCoo.includes(val.value))}
                        labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_CREATED_BY')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val.value),
                            'selectedCoo',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select placement-top mb-0">
                      <p className="field-name">{t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_COLOURWAY')}</p>
                      <MultiSelect
                        name="colorway"
                        options={colorwayOptions || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={colorwayOptions.filter((val) => !isEmpty(selectedColorway) && selectedColorway.includes(val._id))}
                        labelledBy={t('COMPONENT.PRODUCT_FILTER.FILTER.SELECT_COLOURWAY')}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedColorway',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  <FormGroup className="mb-2">
                    <div className="common-react-select mb-0">
                      <p className="field-name">{t('COLOR_LIBRARY.FILTER.SELECT_COLOR_GROUP')}</p>
                      <MultiSelect
                        name="colorGroup"
                        options={colorGroupOptions || []}
                        className="product-custom-multiselect common-new-multiselect w-100"
                        value={colorGroupOptions.filter((val) => !isEmpty(selectedColorGroup) && selectedColorGroup.includes(val._id))}
                        labelledBy={t('COLOR_LIBRARY.FILTER.SELECT_COLOR_GROUP')}
                        overrideStrings={{
                          selectSomeItems: t('COLOR_LIBRARY.FILTER.SELECT_COLOR_GROUP'),
                        }}
                        onChange={(selected) =>
                          setSelectedFilters(
                            selected.map((val) => val._id),
                            'selectedColorGroup',
                          )
                        }
                      />
                    </div>
                  </FormGroup>
                  {licensorAccess && (
                    <>
                      <FormGroup className="mb-2">
                        <div className="common-react-select mb-0">
                          <p className="field-name">{t('LICENSOR_MASTER.SELECT_LICENSOR')}</p>
                          <MultiSelect
                            name="licensor"
                            options={licensorOptions}
                            className="product-custom-multiselect common-new-multiselect w-100"
                            value={licensorOptions.filter((val) => checkArray(selectedLicensor) && selectedLicensor.includes(val._id))}
                            labelledBy={t('LICENSOR_MASTER.SELECT_LICENSOR')}
                            overrideStrings={{ selectSomeItems: t('LICENSOR_MASTER.SELECT_LICENSOR') }}
                            onChange={(selected) =>
                              handleFilterLicense(
                                selected.map((val) => val._id),
                                'selectedLicensor',
                              )
                            }
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-2">
                        <div className="common-react-select mb-0">
                          <p className="field-name">{t('LICENSE_MASTER.SELECT_LICENSE')}</p>
                          <MultiSelect
                            name="license"
                            options={licenseOptions}
                            className="product-custom-multiselect common-new-multiselect w-100"
                            value={licenseOptions.filter((val) => checkArray(selectedLicense) && selectedLicense.includes(val._id))}
                            labelledBy={t('LICENSE_MASTER.SELECT_LICENSE')}
                            overrideStrings={{ selectSomeItems: t('LICENSE_MASTER.SELECT_LICENSE') }}
                            onChange={(selected) =>
                              handleFilterLicense(
                                selected.map((val) => val._id),
                                'selectedLicense',
                              )
                            }
                          />
                        </div>
                      </FormGroup>
                      <FormGroup className="mb-2">
                        <div className="common-react-select mb-0">
                          <p className="field-name">{t('LIKENESS_MASTER.SELECT_LIKENESS')}</p>
                          <MultiSelect
                            name="likeness"
                            options={likenessOptions}
                            className="product-custom-multiselect common-new-multiselect w-100"
                            value={likenessOptions.filter((val) => checkArray(selectedLikeness) && selectedLikeness.includes(val._id))}
                            labelledBy={t('LIKENESS_MASTER.SELECT_LIKENESS')}
                            overrideStrings={{ selectSomeItems: t('LIKENESS_MASTER.SELECT_LIKENESS') }}
                            onChange={(selected) =>
                              handleFilterLicense(
                                selected.map((val) => val._id),
                                'selectedLikeness',
                              )
                            }
                          />
                        </div>
                      </FormGroup>
                    </>
                  )}
                  {allCustomAttributes?.map((cust, i) => {
                    const brandIds = Array.isArray(selectedBrand) ? selectedBrand : [selectedBrand];
                    const productTypeIds = Array.isArray(selectedProductType) ? selectedProductType : [selectedProductType];
                    const matchesBrand = cust?.brand?.length ? cust.brand.some((br) => brandIds.includes(br)) : false;
                    const matchesProductType = cust?.productType?.length ? cust.productType.some((pt) => productTypeIds.includes(pt)) : false;
                    let isEnabled = true;
                    if (brandIds.filter(Boolean).length > 0 && productTypeIds.filter(Boolean).length > 0) {
                      isEnabled = matchesBrand && matchesProductType;
                    }
                    return (
                      <FormGroup className="mb-2" key={i}>
                        <div className="common-react-select placement-top mb-0">
                          <p className="field-name">{cust?.keyName}</p>
                          <MultiSelect
                            name="year"
                            options={cust?.options || []}
                            className="product-custom-multiselect common-new-multiselect w-100"
                            value={cust?.options?.filter((val) => {
                              return some(selectedDynamic, (ele) => ele?.value === val?.valId);
                            })}
                            disabled={!isEnabled}
                            labelledBy={t('RANGE_PLANS.PRODUCT_LIST.FILTER_PRODUCT_LIST.SELECT_CREATED_BY')}
                            onChange={(selected) => setSelectedDynamic(selected, cust?._id)}
                          />
                        </div>
                      </FormGroup>
                    );
                  })}
                </div>
                <div className="d-flex justify-content-end">
                  <CustomTooltip placement="top" tooltipText={t('COSTING_TO_DO_LIST.CLEAR')}>
                    <button onClick={clearAll} aria-label="Close" className="btn p-0 d-inline-flex" type="button">
                      <span className="icon-Clear-New f-24" />
                    </button>
                  </CustomTooltip>
                  <CustomTooltip placement="top" tooltipText={t('COSTING_TO_DO_LIST.APPLY')}>
                    <button onClick={applyFilter} disabled={mainLoader} aria-label="Apply" className="btn p-0 d-inline-flex ml-16" type="button">
                      <span className="icon-Tick-1 f-28" />
                    </button>
                  </CustomTooltip>
                </div>
              </div>
            </Popover.Content>
          </Popover>
        }
      >
        <i className="icon-Filter f-26" />
      </OverlayTrigger>
    </button>
  );
}

export default FilterProductList;
